import { render, staticRenderFns } from "./MainPayAuthority.vue?vue&type=template&id=d64cf91a&scoped=true&"
import script from "./MainPayAuthority.vue?vue&type=script&lang=ts&"
export * from "./MainPayAuthority.vue?vue&type=script&lang=ts&"
import style0 from "./MainPayAuthority.vue?vue&type=style&index=0&id=d64cf91a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64cf91a",
  null
  
)

export default component.exports